var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatIllustration = function SvgChatIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#67BEFA",
    d: "M1.55 14.692C1.55 7.3 7.546 1.305 14.94 1.305c7.18 0 13.039 5.651 13.372 12.748a10.07 10.07 0 0 0-5.536-1.646c-5.59 0-10.122 4.532-10.122 10.122 0 2.044.605 3.945 1.646 5.536a13.3 13.3 0 0 1-6.27-1.904c-1.36.548-2.92 1.116-4.348 1.513-1.082.3-2.057-.63-1.783-1.728.37-1.481.94-3.083 1.505-4.455a13.3 13.3 0 0 1-1.852-6.799"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#034DCA",
    d: "M22.773 14.367a8.163 8.163 0 0 1 7.048 12.284c.262.57.52 1.213.726 1.902.331 1.098-.668 2.046-1.746 1.693a19 19 0 0 1-1.83-.713 8.163 8.163 0 1 1-4.198-15.166"
  })));
};
export default SvgChatIllustration;